import { createInjector } from 'typed-inject';
import baseRouter from '@/main/baseRouter';
import baseStore from '@/main/baseStore';
import { ServiceTokens } from './tokens';
import { UserDetailsStoreServiceFactory } from '@/common/store/user-details/store';
import type { GetInjectionContext } from './types';

export const baseInjector = createInjector()
    .provideValue(ServiceTokens.VueRouter, baseRouter)
    .provideValue(ServiceTokens.BaseStore, baseStore)
    .provideFactory(ServiceTokens.UserDetailsStoreService, UserDetailsStoreServiceFactory);

export type BaseInjectionContext = GetInjectionContext<typeof baseInjector>;
export type BaseInjector = typeof baseInjector;
